import React, { forwardRef } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 0.25rem;
  flex: 1;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    height: 0.5rem;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.forecast.background4} !important;
    border-radius: 0.25rem;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.forecast.background3} !important;
  }
`

interface ScrollContainerProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode
}

export const ScrollContainer = forwardRef<HTMLDivElement, ScrollContainerProps>(
  ({ children, ...props }, ref) => {
    return (
      <Container ref={ref} {...props}>
        {children}
      </Container>
    )
  }
)

ScrollContainer.displayName = 'ScrollContainer'
